
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const dropdownStyles = {
  content: "bg-white border shadow-md rounded-md",
  item: "text-gray-800 hover:bg-gray-100",
}
